function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
import isNil from 'lodash/isNil';
import map from 'lodash/map';
import slice from 'lodash/slice';
import reduce from 'lodash/reduce';
import Papa from 'papaparse';
import { mapState, mapGetters } from 'vuex';
import saveAs from 'file-saver';
export default {
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    completed: function completed(s) {
      return s.api.executionState === 'completed';
    },
    orders: function orders(s) {
      return s.order.order;
    },
    elementsType: function elementsType(s) {
      return s.elements.type;
    },
    distance: function distance(s) {
      return s.elements.distance;
    },
    options: function options(s) {
      return s.elements.globalOptions;
    },
    leftElements: function leftElements(s) {
      return s.elements.left;
    },
    rightElements: function rightElements(s) {
      return s.elements.right;
    },
    filters: function filters(s) {
      return s.filters.values;
    },
    query: function query(s) {
      return s.api.query;
    },
    result: function result(s) {
      return s.api.result;
    }
  })), mapGetters({
    page: 'pagination/currentPage',
    pageSize: 'pagination/currentPageSize',
    // Use the real result type. E.g.: you can only download KWIC when KWIC is shown but not accessing context
    resultType: 'api/resultType'
  })), {}, {
    queryRow: function queryRow() {
      var _this = this,
          _objectSpread2;

      var common = _objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, this.$t('csv.header.result_type'), this.resultType), _defineProperty(_objectSpread2, this.$t('csv.header.order'), this.orders.map(function (n) {
        return _this.$t("order.options.".concat(n));
      }).join(', ')), _defineProperty(_objectSpread2, this.$t('csv.header.page'), this.page), _defineProperty(_objectSpread2, this.$t('csv.header.page_size'), this.pageSize), _objectSpread2), this.translateOptions(this.options)), this.translateFilters(this.filters));

      if (this.elementsType === 'units') {
        if (!isNil(this.distance.type)) {
          var _objectSpread3;

          return _objectSpread(_objectSpread({}, common), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, this.$t('csv.header.distance'), "".concat(this.distance.type === 'lteq' ? '≤ ' : '').concat(this.distance.number)), _defineProperty(_objectSpread3, this.$t('csv.header.left_units'), map(this.leftElements, 'unit.value').join(' ')), _defineProperty(_objectSpread3, this.$t('csv.header.right_units'), map(this.rightElements, 'unit.value').join(' ')), _objectSpread3));
        } else {
          return _objectSpread(_objectSpread({}, common), {}, _defineProperty({}, this.$t('csv.header.units'), map(this.leftElements, 'unit.value').join(' ')));
        }
      } else {
        if (!isNil(this.distance.type)) {
          return _objectSpread(_objectSpread({}, common), {}, _defineProperty({}, this.$t('csv.header.distance'), "".concat(this.distance.type === 'lteq' ? '≤ ' : '').concat(this.distance.number)), this.tokenFields([].concat(_toConsumableArray(this.leftElements), _toConsumableArray(this.rightElements))));
        } else {
          return _objectSpread(_objectSpread({}, common), this.tokenFields(this.leftElements));
        }
      }
    },
    resultRows: function resultRows() {
      var _this2 = this;

      return map(this.result.kwic, function (r) {
        if (!isNil(_this2.distance.type)) {
          var _objectSpread6;

          var middleStart = _this2.leftElements.length;
          var rightStart = r.elements.middle.length - _this2.rightElements.length;
          var left = slice(r.elements.middle, 0, middleStart);
          var middle = slice(r.elements.middle, middleStart, rightStart);
          var right = slice(r.elements.middle, rightStart, r.elements.middle.length);
          return _objectSpread(_objectSpread({}, _this2.$ncsCsvElementFields(r.document, r.text, r.elements, r.matches)), {}, (_objectSpread6 = {}, _defineProperty(_objectSpread6, _this2.$t('csv.result.before'), _this2.joinElements(r.elements.before)), _defineProperty(_objectSpread6, _this2.$t('csv.result.left_matches'), _this2.joinElements(left)), _defineProperty(_objectSpread6, _this2.$t('csv.result.middle'), _this2.joinElements(middle)), _defineProperty(_objectSpread6, _this2.$t('csv.result.right_matches'), _this2.joinElements(right)), _defineProperty(_objectSpread6, _this2.$t('csv.result.after'), _this2.joinElements(r.elements.after)), _objectSpread6));
        } else {
          var _objectSpread7;

          return _objectSpread(_objectSpread({}, _this2.$ncsCsvElementFields(r.document, r.text, r.elements, r.matches)), {}, (_objectSpread7 = {}, _defineProperty(_objectSpread7, _this2.$t('csv.result.before'), _this2.joinElements(r.elements.before)), _defineProperty(_objectSpread7, _this2.$t('csv.result.matches'), _this2.joinElements(r.elements.middle)), _defineProperty(_objectSpread7, _this2.$t('csv.result.after'), _this2.joinElements(r.elements.after)), _objectSpread7));
        }
      });
    }
  }),
  methods: {
    tokenFields: function tokenFields(elements) {
      var _this3 = this;

      return reduce(elements, function (r, e, i) {
        r["".concat(_this3.$t('csv.header.token'), " ").concat(i + 1)] = e.token.value;
        r["".concat(_this3.$t('csv.header.tag'), " ").concat(i + 1)] = e.tag.value;
        r["".concat(_this3.$t('csv.header.lemma'), " ").concat(i + 1)] = e.lemma.value;
        return r;
      }, {});
    },
    translateOptions: function translateOptions(options) {
      var _this4 = this;

      var translate = function translate(r, v, k) {
        return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, _this4.$t("elements.options.".concat(k, ".label")), _this4.$t("elements.options.".concat(k, ".options.").concat(v))));
      };

      return reduce(options, translate, {});
    },
    translateFilters: function translateFilters(filters) {
      var _this5 = this;

      var translate = function translate(r, v, k) {
        return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, _this5.$t("filters.".concat(k, ".label")), _this5.$tOr("filters.".concat(k, ".options"), v)));
      };

      return reduce(filters, translate, {});
    },
    joinElements: function joinElements(elements) {
      var _this6 = this;

      // Microsoft excel cannot handle csv line breaks inside a cell.
      // Since we do not show line breaks in KWIC, it is consistent to remove them from CSV.
      return map(elements, function (e) {
        return _this6.$ncsElementContent(e);
      }).join('').replace('\n', '');
    },
    downloadCsv: function downloadCsv() {
      var delimiter = this.$ncsConfig.download.kwic.delimiter;
      var resultCsv = Papa.unparse(this.resultRows, {
        delimiter: delimiter,
        newline: "\n"
      });
      var parts = [];

      if (this.$ncsConfig.download.kwic.header) {
        var queryCsv = Papa.unparse([this.queryRow], {
          delimiter: delimiter,
          newline: "\n"
        });
        parts = [queryCsv, '\n', resultCsv];
      } else {
        parts = [resultCsv];
      }

      var blob = new Blob(parts, {
        type: "text/csv;charset=utf-8"
      });
      saveAs(blob, this.$ncsConfig.download.kwic.filename);
      this.$ga.page("/search/kwic/download");
    }
  }
};